// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"95453fc9","239":"d0e77f3b","455":"9ff081be"}[chunkId] + ".chunk.js";
};